import React from 'react';

import BaseIcon from '../BaseIcon';

export const CheckboxUncheck = (props) => (
    <BaseIcon {...props} viewBox="0 0 58 58">
        <path d="M49 48H6.817V6.799H49C49 4.5223 49 2.2457 49-.031H6.817C3.03.037-.148 2.539-.081 6.866v41.073C.011 52.538 3.494 54.949 6.71 55H49.036C52.446 54.981 55.955 51.522 56 47.839 56 34.226 56 20.613 56 7 56 4.5 53.5 0 49 0h0v25.106z" />
    </BaseIcon>
);
